export function getHeight(fitToWidth, width, height, isSlider = false) {
  // if (fitToWidth && !isSlider) {
  //   const hgt = (470 * height) / 100;
  //   const wdth = (1440 * width) / 100;
  //   return `${(window.innerWidth / wdth) * hgt / (100 / width)}px`;
  // }
  const hgt = (470 * height) / 100;
  const wdth = (1440 * width) / 100;
  return `${((window.innerWidth / wdth) * hgt) / Math.floor(100 / width)}px`;
}

export function getWidth(width) {
  // return `${width}%`;
  return `${(window.innerWidth * width) / 100}px`;
}

export function componentHaveEnoughBanners(banners) {
  return Math.round(banners.reduce((acc, { width }) => acc + width, 0)) >= 100;
}
